import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../../CommonControlls/CommonJs";
import MainLayout from "../../CommonControlls/MainLayout";
import Topmenu from "../../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class District_List extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedinUser: 0,

			Parameters: {},
			// Table
			data: [],
			page: 1,
			sizePerPage: 15,
			TotalRecord: 0,
			loading: false,
			exportLoading: false,

			permissions: [],
			startDate: moment(new Date()).subtract(3, "months").toDate(),
			endDate: new Date(),

			sortField: "id",

			loadingExport: false,
		};
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}

		Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
			this.setState({
				loggedinUser: user.id,
			});
		});
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_District_Report");
		this.PopulateTable();
		$(".Search_InputField").on("keypress", (e) => {
			if (e.which === 13) {
				this.PopulateTable();
			}
		});

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter((p) => p.permissioN_GROUP === "Users" && p.permissioN_ALLOWED)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
		if (type === "sort") {
			let tempFieldorderLabel = sortField + "sortOrder";
			let tempFieldorder =
				this.state[tempFieldorderLabel] === ""
					? sortOrder
					: this.state[tempFieldorderLabel] === "asc"
					? "desc"
					: "asc";
			this.setState(
				{
					sortField,
					[tempFieldorderLabel]: tempFieldorder,
				},
				() => {
					this.PopulateTable();
				}
			);
			return;
		}
		this.setState(
			{
				page,
				sizePerPage,
			},
			() => {
				this.PopulateTable();
			}
		);
	};

	ExportData = () => {
		this.setState(
			(prevState) => ({
				Parameters: {
					...prevState.Parameters,
					pageSize: this.state.TotalRecord,
				},
				exportLoading: true,
			}),
			() => {
				Common.Ajax(
					this.props.UserAuthentication.AuthToken,
					"Get",
					false,
					Common.APILinks.GetDistrictReport,
					this.state.Parameters,
					(resp) => {
						$("#FormSearchBtn").prop("disabled", false);
						this.setState({ loading: false });
						if (resp.status) {
							this.setState({
								data: resp.data,
								exportLoading: false,
							});
							$(".react-bs-table-csv-btn").click();
							setTimeout(() => {
								this.PopulateTable();
							}, 500);
						}
					}
				);
			}
		);
	};

	PopulateTable = () => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ loading: true, data: [], TotalRecord: 0 });

		const Parameters = {
			pageSize: this.state.sizePerPage,
			pageNumber: this.state.page,
			fromDate:
				this.state.startDate == null || this.state.startDate === ""
					? null
					: Common.ConvertToUtcDateTime(
							Common.getOnlyDate(this.state.startDate) + " 00:00:00"
					  ),
			toDate:
				this.state.endDate == null || this.state.endDate === ""
					? null
					: Common.ConvertToUtcDateTime(
							Common.getOnlyDate(this.state.endDate) + " 23:59:59"
					  ),
		};

		this.setState({ Parameters });

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.GetDistrictReport,
			Parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				if (resp.status) {
					this.setState({
						data: resp.data,
						TotalRecord: 200,
					});
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	HandleDateChange = (Field, date) => {
		this.setState(
			{ [Field]: date === "" || date == null ? new Date() : date },
			() => {
				if (
					Field === "startDate" &&
					this.state.startDate > this.state.endDate
				) {
					this.setState({ endDate: this.state.startDate });
				}
			}
		);
	};

	render() {
		const columns = [
			{
				dataField: "district",
				text: "District",
				headerStyle: () => {
					return { fontSize: "13px", width: "100px" };
				},
				sort: true,
			},
			{
				dataField: "provinces",
				text: "Province",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "totalUploadedSamples",
				text: "Total Uploaded Samples",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "samplesAssignedToRiders",
				text: "Samples Assigned to Riders",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "totalTransportedSamples",
				text: "Total Transported Samples",
				headerStyle: (colum, colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
			},
			{
				dataField: "samplesTransportedForGXSites",
				text: "Samples Transported for GX Sites",
				headerStyle: (colum, colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
			},
			{
				dataField: "samplesTransportedForGXSites",
				text: "Transported & GX Tested Samples",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
			},
			{
				dataField: "mtbDetectedSamples",
				text: "MTB Detected Samples",
				sort: true,
				headerStyle: (colum, colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "rrDetectedSamples",
				text: "RR Detected Samples",
				headerStyle: (colum, colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
				csvExport: true,
			},
			{
				dataField: "samplesTransportedForAFBTest",
				text: "Samples Transported for AFB Test",
				headerStyle: (colum, colIndex) => {
					return { width: "160px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "transportedAFBTestedSamples",
				text: "Transported & AFB Tested Samples",
				headerStyle: (colum, colIndex) => {
					return { width: "220px" };
				},
				sort: true,
			},
			{
				dataField: "afbPositiveSample",
				text: "AFB Positive Sample",
				headerStyle: (colum, colIndex) => {
					return { width: "70px", fontSize: "13px" };
				},
			},
		];

		return (
			<div>
				<MainLayout />
				<div id="right-panel" class="right-panel">
					{/* this.state.permissions.includes('users-add') */}
					<Topmenu PageTitle="District Report" />
					<div class="content">
						<div class="card">
							<div class="card-body">
								<div class="Table_Search row">
									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">From</label>
										<DatePicker
											selected={this.state.startDate}
											onChange={(date) => {
												this.HandleDateChange("startDate", date);
											}}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">To</label>
										<DatePicker
											selected={this.state.endDate}
											onChange={(date) => {
												this.HandleDateChange("endDate", date);
											}}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											minDate={this.state.startDate}
										/>
									</div>

									<div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<button
											onClick={() => {
												this.PopulateTable();
											}}
											style={{ position: "relative", marginTop: 36 }}
											id="FormSearchBtn"
											class="btn SearchTable_Btn"
										>
											Search
										</button>
									</div>
								</div>

								<Table
									keyField="id"
									data={this.state.data}
									page={this.state.page}
									sizePerPage={this.state.sizePerPage}
									changeSizePerPage={() => this.ExportData()}
									// exportAllowed={this.state.permissions.includes(
									// 	"st_progress_report_district"
									// )}
									exportAllowed
									totalSize={this.state.TotalRecord}
									exportLoading={this.state.exportLoading}
									onTableChange={this.handleTableChange}
									isPagination={true}
									columns={columns}
									pdfExportLoading={this.state.loadingExport}
									loading={this.state.loading}
									RefreshTable={this.PopulateTable}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(District_List);
